module.exports = __webpack_public_path__ + "img/botaovarginhasetsul.0de81f34.png";